import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "..";
import { Button, CustomLink, Input, Keyboard, Layout } from "../components";
import logo from "../assets/logo.svg";
import $api from "../http";
import config from "../config";
import { observer } from "mobx-react";

const InputPhone: FC<{ title: string }> = observer(({ title }) => {
  const { store } = useContext(Context);
  const navigate = useNavigate();

  useEffect(() => {
    if (!store.isAuth) return navigate("/");
  }, [store, navigate]);

  const [phone, setPhone] = useState<string>("8");

  const sendData = () => {
    if (!phone) return alert("Укажите номер телефона");
    store.setSelectedPhone(phone);
    $api.get(`${config.API}/client/get?phone=${phone.replaceAll("+", "%2B")}`).then(({ data }) => {
      if (data.status === "error") return navigate("/default/reg");
      store.setClientName(data.data.name);
      store.setJoins(data.data.count);
      navigate("/default/order");
    });
  };

  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={128} height={128} />
      <CustomLink to={"/default/services"}>{"<-"} Выбор услуг</CustomLink>
      <Input value={phone} onChange={({ target }) => setPhone(target.value)} placeholder="Номер телефона" />
      <Keyboard
        type="phone"
        onClick={(e: string) => {
          if (e === "<-") return setPhone((prev) => prev.substring(0, prev.length - 1));
          setPhone((prev) => (prev += e));
        }}
      />
      <Button onClick={sendData}>Продолжить</Button>
    </Layout>
  );
});

export default InputPhone;
